/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-05 09:47:37
 * @LastEditTime: 2020-08-26 09:17:11
 * @Description: 销售项目配方
 */
import {
    getRecipeSales,
    getRecipeSalesById,
    createRecipeSales,
    getSalesCurrentRecipeProd,
    verifyRecipeSales,
    verifyAllRecipe,
    updateRecipeSales,
    deleteRecipeSales,
    setProdRecipeSales,
    getRecipeContainMaterial,
    bulkReplaceRecipeMaterial,
    getRecipeSalesWithMaterialDetail
} from '@/api/recipeSales'
import Vue from 'vue'

const state = {
    recipeSalesList: [],
    prodRecipeSales: {},
    totalCounts: 0
}

const actions = {
    async getRecipeSalesAction({
        commit
    }, payload) {
        try {
            const recipeSalesList = await getRecipeSales(payload)
            commit('SETRECIPESALES', recipeSalesList.data)
            return recipeSalesList.data
        } catch (error) {
            throw error.message
        }

    },
    async getRecipeSalesByIdAction({
        commit
    }, id) {
        try {
            const recipeSales = await getRecipeSalesById(id)
            recipeSales.data.detail = recipeSales.data.detail.map((e) => {
                return {
                    ...e.material,
                    "ratio": e.ratio
                }
            })
            return recipeSales.data
        } catch (error) {
            throw error.message
        }
    },
    // 通过材料id获取配方
    async getRecipeContainMaterialAction({
        commit
    }, id) {
        try {
            const recipeSalesList = await getRecipeContainMaterial(id)
            commit('SET_MATERIAL_SEARCH_RECIPESALES', recipeSalesList.data)
            return recipeSalesList.data
        } catch (error) {
            throw error.message
        }
    },
    // 替换材料
    async bulkReplaceRecipeMaterialAction({
        commit
    }, payload) {
        try {
            const newRecipeSales = await bulkReplaceRecipeMaterial(payload)
            commit("BULK_REPLACE_RECIPE_MATERIAL", payload)
            return newRecipeSales.data
        } catch (error) {
            throw error.message
        }
    },
    async createRecipeSalesAction({
        commit
    }, payload) {
        try {
            const newRecipe = await createRecipeSales(payload);
            return newRecipe.data
        } catch (error) {
            throw error.message
        }
    },
    async getSalesCurrentRecipeProdAction({
        commit
    }, payload) {
        try {
            const recipe = await getSalesCurrentRecipeProd(payload);
            return recipe.data;
        } catch (error) {
            throw error.message
        }
    },

    async verifyRecipeSalesAction({
        commit
    }, payload) {
        try {
            const newRecipe = await verifyRecipeSales(payload.id, payload.data);
            return newRecipe.data
        } catch (error) {
            throw error
        }
    },
    async updateRecipeSalesAction({
        commit
    }, payload) {
        try {
            const newRecipeSales = await updateRecipeSales(payload.id, payload.data)
            if (!payload.data.type) {
                commit("UPDATE_RECIPESALES", payload)
            }
            return newRecipeSales.data
        } catch (error) {
            throw error.message
        }
    },
    async setProdRecipeSalesAction({
        commit
    }, payload) {
        try {

            const newRecipe = await setProdRecipeSales(payload.id, payload.data);
            return newRecipe.data
        } catch (error) {
            throw error
        }
    },
    async deleteRecipeSalesAction({
        commit
    }, payload) {
        try {
            await deleteRecipeSales(payload.id)
            commit('DELETE_RECIPESALES', payload.id)
            return payload.id
        } catch (error) {
            throw error
        }
    },
    async getRecipeSalesWithMaterialDetailAction({
        commit
    }, payload) {
        try {
            const recipeSales = await getRecipeSalesWithMaterialDetail(payload.id, payload.data)
            return recipeSales.data
        } catch (error) {
            throw error.message
        }
    },
}

const mutations = {
    SETRECIPESALES(state, payload) {
        payload.recipeSalesList.forEach((x) => {
            if (x.prevRecipeSales && x.detail) {
                const res = new Map();
                x.allDetail = x.detail.concat(x.prevRecipeSales.detail).filter(x => {
                    return !res.has(x.material._id) && res.set(x.material._id, 1)
                })
            }
        });
        state.recipeSalesList = payload.recipeSalesList
        state.totalCounts = payload.totalCounts
    },
    SET_MATERIAL_SEARCH_RECIPESALES(state, payload) {
        state.recipeSalesList = payload.recipeSalesList
        state.totalCounts = payload.totalCounts
    },
    UPDATE_RECIPESALES(state, recipeSales) {
        const index = state.recipeSalesList.findIndex(x => x._id === recipeSales.id)
        const newRecipeSales = state.recipeSalesList[index]
        if (recipeSales.data.status) {
            newRecipeSales.status = recipeSales.data.status
        }
        Vue.set(state.recipeSalesList, index, newRecipeSales)
    },
    BULK_REPLACE_RECIPE_MATERIAL(state, recipeSales) {

    },
    DELETE_RECIPESALES(state, id) {
        state.recipeSalesList = state.recipeSalesList.filter(e => e._id !== id)
        state.totalCounts--
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}